<script>

const fieldsFormatKey = {
  years: 'y',
  months: 'M',
  weeks: 'w',
  days: 'd',
  hours: 'h',
  minutes: 'm',
  seconds: 's'
};

const fieldsLabel = {
  years: 'Années',
  months: 'Mois',
  weeks: 'Semaines',
  days: 'Jours',
  hours: 'Heures',
  minutes: 'Minutes',
  seconds: 'Secondes'
};

const durationRegexp = /P(?:(?<years>\d+)Y)?(?:(?<months>\d+)M)?(?:(?<weeks>\d+)W)?(?:(?<days>\d+)D)?(?:T(?:(?<hours>\d+)H)?(?:(?<minutes>\d+)M)?(?:(?<seconds>\d+)S)?)?/;
function parseDuration (str) {
  const match = durationRegexp.exec(str);
  if (match == null) {
    return null;
  }

  const result = match.groups;
  for (const key in result) {
    if (result[key] !== undefined) {
      result[key] = parseInt(result[key]);
    } else {
      result[key] = 0;
    }
  }

  return result;
}

export default {
  name: 'DurationInput',
  props: {
    value: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: 'yMdhms'
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    form: {
      years: null,
      months: null,
      weeks: null,
      days: null,
      hours: null,
      minutes: null,
      seconds: null
    }
  }),
  computed: {
    fields () {
      return Object.keys(this.form).filter(key => this.format.includes(fieldsFormatKey[key]));
    },
    inner_value () {
      let str = 'P' +
        this.buildValuePart(this.form.years, 'Y') +
        this.buildValuePart(this.form.months, 'M') +
        this.buildValuePart(this.form.weeks, 'W') +
        this.buildValuePart(this.form.days, 'D') +
        'T' +
        this.buildValuePart(this.form.hours, 'H') +
        this.buildValuePart(this.form.minutes, 'M') +
        this.buildValuePart(this.form.seconds, 'S');

      str = str.replace(/T$/, '');

      if (str === 'P') {
        return null;
      }

      return str;
    }
  },
  watch: {
    value () { this.valueChange(); },
    inner_value () { this.updateValue(); },
    form () { this.updateValue(); }
  },
  created () {
    this.valueChange();
  },
  methods: {
    valueChange () {
      Object.assign(this.form, parseDuration(this.value));
    },
    updateValue () {
      this.$emit('input', this.inner_value);
    },
    buildValuePart (val, unit) {
      if (!val) {
        return '';
      } else {
        return '' + val + unit;
      }
    },
    getLabel (key) {
      return fieldsLabel[key];
    }

  }
};
</script>
<template>
  <div class="cnt">
    <div class="_inputs">
      <div
        v-for="field in fields"
        :key="field"
        class="_input"
      >
        <label class="label">
          {{ getLabel(field) }}
        </label>

        <NumberField
          v-model="form[field]"
          class="field"
          step="1"
          min="0"
          length="6"
          hide-details
          :disabled="disabled"
          :error="!!(rules && rules.length)"
          @change="updateValue()"
        />
      </div>
    </div>
    <v-input
      error
      :messages="rules"
      style="width:100%"
    />
  </div>
</template>

<style lang="scss" scoped>
.field {
  display: inline-block;
}
._inputs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  ._input {
    box-sizing: border-box;
    width: 5em;
    display: flex;
    flex-direction: column;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>
